import { Pipe, PipeTransform } from '@angular/core';

/**
 * Strips HTML tags from text while preserving email addresses in angle brackets.
 *
 * This pipe removes HTML markup like <b>, <div>, <script> etc. but keeps
 * email addresses like <email@example.com> intact.
 *
 * The distinction is made by checking that HTML tag names can only contain
 * letters, numbers, and hyphens - while email addresses contain @ and/or .
 * which cause the HTML tag pattern to not match.
 */
@Pipe({
    name: 'textSanitize'
})
export class TextSanitizerPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }
    // Strip HTML tags but preserve email addresses in angle brackets
    // HTML tag pattern: <tagname> or </tagname> or <tagname attributes>
    // Tag names must start with a letter and contain only letters, numbers, or hyphens
    // Email addresses like <user@domain.com> won't match because @ and . break the pattern
    return value.replace(/<\/?[a-zA-Z][a-zA-Z0-9-]*(?:\s[^>]*)?\/?>/g, '');
  }

}
